// src/theme/win31.ts
import { theme } from 'antd';

export const xpTheme = {
      algorithm: theme.defaultAlgorithm,

  // 全局 Design Token
  token: {
    // 主色 – iOS 系统蓝
    colorPrimary: '#007AFF',
    colorPrimaryHover: '#3395FF',
    colorPrimaryActive: '#0055CC',
    colorPrimaryBg: '#E6F0FF',

    // 功能色 – iOS 标准
    colorSuccess: '#34C759',      // 系统绿
    colorWarning: '#FF9500',      // 系统橙
    colorError: '#FF3B30',        // 系统红
    colorInfo: '#007AFF',

    // 背景色 – iOS 浅色模式背景
    colorBgBase: '#FFFFFF',       // 基础白
    colorBgContainer: '#FFFFFF',  // 容器白
    colorBgElevated: '#F8F8FC',   // 浮层/卡片背景微灰
    colorBgLayout: '#F2F2F7',     // 页面/分组背景（iOS group table）
    colorBgSpotlight: 'rgba(0,0,0,0.75)', // 工具提示背景

    // 文字色 – 系统黑与灰
    colorTextBase: '#000000',
    colorTextSecondary: '#3C3C43',        // 二级文字，透明度 0.6
    colorTextTertiary: '#8E8E93',         // 三级文字
    colorTextQuaternary: '#C7C7CC',        // 四级文字

    // 边框 – 极浅灰色（iOS 分割线）
    colorBorder: '#E5E5EA',
    colorBorderSecondary: '#E5E5EA',

    // 圆角 – 大圆角（iOS 风格）
    borderRadius: 12,
    borderRadiusSM: 8,
    borderRadiusLG: 16,
    borderRadiusXS: 4,
    borderRadiusOuter: 12,

    // 字体 – iOS 系统字体
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Helvetica Neue', Arial, sans-serif",
    fontFamilyCode: "'SF Mono', 'Menlo', 'Consolas', monospace",

    // 阴影 – 轻量柔和
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
    boxShadowSecondary: '0 4px 20px rgba(0, 0, 0, 0.06)',

    // 控制组件尺寸（适合触控）
    controlHeight: 40,
    controlHeightSM: 32,
    controlHeightLG: 48,
    controlHeightXS: 24,

    // 间距
    padding: 20,
    paddingSM: 12,
    paddingLG: 24,
    paddingXS: 8,
    margin: 20,
    marginSM: 12,
    marginLG: 24,
    marginXS: 8,

    // 边框宽度 – 细线
    lineWidth: 1,
    lineWidthBold: 2,

    // 动效 – 保留平滑过渡
    motion: true,
    motionUnit: 0.3,
    motionBase: 0,
  },

  // 组件级定制
  components: {
    // ========== 通用组件 ==========
    Button: {
      borderRadius: 12,
      // 使用轻量阴影，主按钮无边框，采用纯色背景
      primaryShadow: 'none',
      defaultShadow: 'none',
      defaultBorderColor: 'transparent',
      defaultHoverBorderColor: 'transparent',
      defaultHoverColor: '#007AFF',
      defaultHoverBg: 'rgba(0, 122, 255, 0.08)',
      contentFontSize: 16,
      contentFontSizeLG: 18,
      contentFontSizeSM: 14,
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
      borderColor: 'transparent',
      borderWidth: 0,
      fontWeight: '600',
      colorPrimaryHover: '#3395FF',
      colorPrimaryActive: '#0055CC',
    },

    Layout: {
      headerBg: '#F8F8FC',          // 导航栏浅灰
      headerColor: '#000000',
      headerPadding: '0 20px',
      bodyBg: '#F2F2F7',            // 页面背景（grouped）
      footerBg: '#F2F2F7',
      footerPadding: '8px 20px',
      triggerBg: '#FFFFFF',
      triggerColor: '#007AFF',
      triggerHeight: 48,
      zeroTriggerHeight: 48,
    },

    Menu: {
      itemBg: 'transparent',
      subMenuItemBg: 'rgba(0,0,0,0.02)',
      itemColor: '#000000',
      itemSelectedColor: '#007AFF',
      itemSelectedBg: 'rgba(0, 122, 255, 0.08)',
      itemActiveBg: 'rgba(0, 122, 255, 0.12)',
      itemBorderRadius: 8,
      controlHeightLG: 40,
      itemMarginInline: 8,
      borderColor: 'transparent',
      borderWidth: 0,
    },

    Breadcrumb: {
      colorText: '#3C3C43',
      colorTextSecondary: '#007AFF',
      lastItemColor: '#000000',
      separatorColor: '#8E8E93',
    },

    Pagination: {
      borderRadius: 8,
      colorPrimary: '#007AFF',
      colorBgContainer: '#FFFFFF',
      colorBorder: '#E5E5EA',
      borderWidth: 1,
    },

    Steps: {
      colorPrimary: '#007AFF',
      colorText: '#3C3C43',
      colorTextSecondary: '#8E8E93',
      colorBgContainer: '#FFFFFF',
      borderRadius: 8,
    },

    Tabs: {
      colorPrimary: '#007AFF',
      colorText: '#3C3C43',
      colorTextActive: '#007AFF',
      colorTextHover: '#3395FF',
      colorBorder: '#E5E5EA',
      cardBg: '#FFFFFF',
      cardGutter: 4,
      horizontalMargin: '0 0 12px 0',
      horizontalItemGutter: 16,
      borderWidth: 0,
    },

    // ========== 数据录入 ==========
    Input: {
      colorBgContainer: '#F8F8FC',      // iOS 输入框背景微灰
      colorBorder: '#E5E5EA',
      colorPrimaryHover: '#007AFF',
      borderRadius: 10,
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
      activeBg: '#F8F8FC',
      activeBorderColor: '#007AFF',
      hoverBorderColor: '#007AFF',
      borderWidth: 1,
    },

    Select: {
      colorBgContainer: '#F8F8FC',
      colorBorder: '#E5E5EA',
      borderRadius: 10,
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
      optionSelectedBg: 'rgba(0, 122, 255, 0.08)',
      optionActiveBg: 'rgba(0, 122, 255, 0.05)',
      borderWidth: 1,
    },

    Cascader: {
      colorBgContainer: '#F8F8FC',
      colorBorder: '#E5E5EA',
      borderRadius: 10,
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
      borderWidth: 1,
    },

    DatePicker: {
      colorBgContainer: '#F8F8FC',
      colorBorder: '#E5E5EA',
      borderRadius: 10,
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
      cellHeight: 30,
      cellWidth: 36,
      borderWidth: 1,
    },

    TimePicker: {
      colorBgContainer: '#F8F8FC',
      colorBorder: '#E5E5EA',
      borderRadius: 10,
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
      borderWidth: 1,
    },

    InputNumber: {
      colorBgContainer: '#F8F8FC',
      colorBorder: '#E5E5EA',
      borderRadius: 10,
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
      borderWidth: 1,
    },

    Checkbox: {
      colorPrimary: '#007AFF',
      colorBorder: '#C7C7CC',
      borderRadius: 6,
      controlInteractiveSize: 20,
    },

    Radio: {
      colorPrimary: '#007AFF',
      colorBorder: '#C7C7CC',
      radioSize: 20,
      dotSize: 10,
    },

    Switch: {
      colorPrimary: '#34C759',          // iOS 开关开启绿色
      colorPrimaryHover: '#34C759',
      handleBg: '#FFFFFF',
      handleShadow: '0 2px 4px rgba(0,0,0,0.2)',
      trackHeight: 30,
      trackMinWidth: 52,
      innerMinMargin: 4,
    },

    Slider: {
      colorPrimary: '#007AFF',
      colorPrimaryHover: '#3395FF',
      colorPrimaryBorder: '#007AFF',
      colorPrimaryBorderHover: '#3395FF',
      trackBg: '#007AFF',
      trackHoverBg: '#3395FF',
      handleColor: '#007AFF',
      handleSize: 20,
      handleSizeHover: 22,
      dotSize: 8,
    },

    Rate: {
      colorPrimary: '#FF9500',
      starSize: 24,
      starBg: '#E5E5EA',
    },

    Upload: {
      colorPrimary: '#007AFF',
      colorBorder: '#E5E5EA',
      borderRadius: 12,
      borderWidth: 1,
    },

    Form: {
      labelColor: '#000000',
      labelFontSize: 16,
      labelHeight: 40,
      itemMarginBottom: 20,
    },

    Mentions: {
      colorBgContainer: '#F8F8FC',
      colorBorder: '#E5E5EA',
      borderRadius: 10,
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
      borderWidth: 1,
    },

    AutoComplete: {
      colorBgContainer: '#F8F8FC',
      colorBorder: '#E5E5EA',
      borderRadius: 10,
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
      borderWidth: 1,
    },

    TreeSelect: {
      colorBgContainer: '#F8F8FC',
      colorBorder: '#E5E5EA',
      borderRadius: 10,
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
      borderWidth: 1,
    },

    ColorPicker: {
      colorBgContainer: '#F8F8FC',
      colorBorder: '#E5E5EA',
      borderRadius: 10,
      controlHeight: 40,
      borderWidth: 1,
    },

    Transfer: {
      colorBgContainer: '#F8F8FC',
      colorBorder: '#E5E5EA',
      borderRadius: 12,
      listWidth: 200,
      listHeight: 240,
      borderWidth: 1,
    },

    // ========== 数据展示 ==========
    Table: {
      borderColor: '#E5E5EA',
      headerBg: '#F2F2F7',            // iOS 分组表头背景
      headerColor: '#8E8E93',
      headerSortActiveBg: '#E8E8ED',
      headerSortHoverBg: '#E8E8ED',
      rowHoverBg: 'rgba(0, 122, 255, 0.05)',
      rowSelectedBg: 'rgba(0, 122, 255, 0.10)',
      rowSelectedHoverBg: 'rgba(0, 122, 255, 0.15)',
      cellPaddingInline: 16,
      cellPaddingBlock: 12,
      borderRadius: 12,
      borderWidth: 1,
    },

    Card: {
      colorBgContainer: '#FFFFFF',
      colorBorderSecondary: '#E5E5EA',
      boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
      borderRadiusLG: 16,
      padding: 20,
      paddingSM: 16,
      paddingLG: 24,
      headerBg: 'transparent',
      headerFontSize: 18,
      borderWidth: 0,
    },

    List: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#E5E5EA',
      colorText: '#000000',
      colorTextSecondary: '#3C3C43',
      padding: 16,
      paddingSM: 12,
      paddingLG: 20,
      metaMargin: 16,
    },

    Descriptions: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#E5E5EA',
      colorText: '#000000',
      colorTextSecondary: '#3C3C43',
      labelColor: '#8E8E93',
      titleColor: '#000000',
      padding: 16,
      paddingSM: 12,
      paddingLG: 20,
      borderRadius: 12,
      borderWidth: 1,
    },

    Avatar: {
      colorBgContainer: '#E5E5EA',
      colorText: '#3C3C43',
      borderRadius: 22,               // 完全圆角（头像）
      borderRadiusLG: 28,
      borderRadiusSM: 18,
      size: 40,
      sizeLG: 56,
      sizeSM: 28,
    },

    Badge: {
      borderRadius: 12,
      colorBgContainer: '#FF3B30',
      colorText: '#FFFFFF',
      dotSize: 8,
      shadowSize: 0,
    },

    Tag: {
      colorBgContainer: '#F2F2F7',
      colorBorder: 'transparent',
      colorText: '#007AFF',
      borderRadius: 8,
      defaultBg: '#F2F2F7',
      defaultColor: '#007AFF',
      borderWidth: 0,
    },

    Popover: {
      colorBgContainer: '#FFFFFF',
      colorBorder: 'rgba(0,0,0,0.05)',
      borderRadius: 14,
      boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
      padding: 16,
      borderWidth: 1,
    },

    Tooltip: {
      colorBgSpotlight: 'rgba(0,0,0,0.75)',
      colorTextLightSolid: '#FFFFFF',
      borderRadius: 8,
      fontSize: 13,
      padding: 8,
    },

    Popconfirm: {
      colorBgContainer: '#FFFFFF',
      colorBorder: 'rgba(0,0,0,0.05)',
      borderRadius: 14,
      boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
      borderWidth: 1,
    },

    Dropdown: {
      colorBgContainer: '#FFFFFF',
      colorBorder: 'rgba(0,0,0,0.05)',
      borderRadius: 12,
      boxShadow: '0 4px 20px rgba(0,0,0,0.10)',
      padding: 4,
      borderWidth: 1,
    },

    Tree: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#E5E5EA',
      colorText: '#000000',
      colorTextSecondary: '#3C3C43',
      nodeHoverColor: 'rgba(0, 122, 255, 0.04)',
      nodeSelectedColor: 'rgba(0, 122, 255, 0.08)',
      indentSize: 16,
      borderRadius: 8,
    },

    Calendar: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#E5E5EA',
      colorText: '#000000',
      colorTextSecondary: '#3C3C43',
      fullBg: '#F2F2F7',
      fullPanelBg: '#FFFFFF',
      itemActiveBg: 'rgba(0, 122, 255, 0.10)',
    },

    Statistic: {
      colorBgContainer: '#FFFFFF',
      colorText: '#000000',
      colorTextSecondary: '#3C3C43',
      titleFontSize: 14,
      contentFontSize: 24,
    },

    Comment: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#E5E5EA',
      colorText: '#000000',
      colorTextSecondary: '#3C3C43',
      padding: 16,
    },

    Carousel: {
      colorBgContainer: '#E5E5EA',
      colorText: '#3C3C43',
      dotHeight: 4,
      dotWidth: 20,
    },

    Collapse: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#E5E5EA',
      colorText: '#000000',
      colorTextSecondary: '#3C3C43',
      headerBg: 'transparent',
      borderRadius: 12,
      padding: 16,
      borderWidth: 1,
    },

    Timeline: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#E5E5EA',
      colorText: '#000000',
      colorTextSecondary: '#3C3C43',
      dotBg: '#007AFF',
      tailColor: '#E5E5EA',
    },

    // ========== 反馈组件 ==========
    Alert: {
      borderRadius: 12,
      colorText: '#000000',
      colorTextSecondary: '#3C3C43',
      padding: 16,
      paddingSM: 12,
      borderWidth: 0,
    },

    Notification: {
      colorBgContainer: '#FFFFFF',
      colorBorder: 'rgba(0,0,0,0.05)',
      borderRadius: 16,
      boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
      padding: 20,
      paddingLG: 24,
      borderWidth: 1,
    },

    Message: {
      colorBgContainer: '#FFFFFF',
      colorBorder: 'rgba(0,0,0,0.05)',
      borderRadius: 16,
      boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
      padding: 16,
      borderWidth: 1,
    },

    Modal: {
      borderRadiusLG: 20,
      boxShadow: '0 8px 40px rgba(0,0,0,0.15)',
      colorBgContainer: '#FFFFFF',
      colorBorder: 'rgba(0,0,0,0.05)',
      headerBg: 'transparent',
      headerColor: '#000000',
      titleColor: '#000000',
      titleFontSize: 20,
      padding: 24,
      paddingLG: 32,
      paddingMD: 20,
      paddingXS: 16,
      borderWidth: 0,
    },

    Drawer: {
      colorBgContainer: '#FFFFFF',
      colorBorder: 'rgba(0,0,0,0.05)',
      borderRadiusLG: 0,
      boxShadow: '0 4px 20px rgba(0,0,0,0.10)',
      padding: 24,
      titleColor: '#000000',
      titleFontSize: 20,
      borderWidth: 0,
    },

    Progress: {
      colorBgContainer: '#E5E5EA',
      colorText: '#3C3C43',
      colorTextSecondary: '#8E8E93',
      defaultColor: '#007AFF',
      remainingColor: '#E5E5EA',
      borderRadius: 4,
      lineWidth: 8,
    },

    Result: {
      colorBgContainer: '#FFFFFF',
      colorText: '#000000',
      colorTextSecondary: '#3C3C43',
      titleFontSize: 24,
      subtitleFontSize: 16,
      iconSize: 56,
    },

    Skeleton: {
      colorBgContainer: '#E5E5EA',
      colorText: '#F2F2F7',
      borderRadius: 8,
    },

    Empty: {
      colorBgContainer: 'transparent',
      colorText: '#3C3C43',
      colorTextSecondary: '#8E8E93',
    },

    Spin: {
      colorPrimary: '#007AFF',
      colorBgContainer: 'rgba(242, 242, 247, 0.6)',
    },

    // ========== 其他 ==========
    Anchor: {
      colorBgContainer: 'transparent',
      colorBorder: '#E5E5EA',
      colorText: '#3C3C43',
      colorTextActive: '#007AFF',
      colorTextHover: '#007AFF',
    },

    BackTop: {
      colorBgContainer: 'rgba(255,255,255,0.85)',
      colorBorder: 'rgba(0,0,0,0.05)',
      boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
      borderWidth: 0,
    },

    App: {
      colorBgContainer: '#F2F2F7',
      colorText: '#000000',
    },

    QRCode: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#E5E5EA',
      borderRadius: 12,
      borderWidth: 1,
    },

    Tour: {
      colorBgContainer: '#FFFFFF',
      colorBorder: 'rgba(0,0,0,0.05)',
      borderRadius: 16,
      boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
      borderWidth: 1,
    },
  },
};